var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDriveAlarm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 385"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 284",
    cx: 43,
    cy: 61,
    rx: 8,
    ry: 8,
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 285",
    cx: 43,
    cy: 26,
    rx: 6,
    ry: 6,
    fill: "#A9E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 342",
    d: "M18 51.4259C18 50.3213 18.8926 49.4224 19.9965 49.3837C22.9268 49.2809 28.2843 48.9274 30.5 47.7129C33.625 46 43 46 43 46C43 46 52.375 46 55.5 47.7129C57.7157 48.9274 63.0732 49.2809 66.0035 49.3837C67.1074 49.4224 68 50.3213 68 51.4259V58C68 59.1046 67.1046 60 66 60H20C18.8954 60 18 59.1046 18 58V51.4259Z",
    fill: "#A9E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 343",
    d: "M25 40C25 32.268 31.268 26 39 26H46C53.732 26 60 32.268 60 40V57H25V40Z",
    fill: "#A9E2FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDriveAlarm);
export default __webpack_public_path__ + "static/media/IcDriveAlarm.08ac2a8676ed21c6905e9664cd377a31.svg";
export { ForwardRef as ReactComponent };